export const setIsTourModalOpenActionType = "tour/modal";
export const setIsTourRunningActionType = "tour/running";
export const setTourStepActionType = "tour/step";
